import React from "react";
import { Row, Col, Button, Card } from "antd";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Logo1 from "../../assests/images/Aditya Birla Capital Ltd Logo Download - SVG - All Vector Logo.jpeg";
import Logo2 from "../../assests/images/Jana_Bank_Master_logo.jpg";
import Logo3 from "../../assests/images/Kotak_Life.png";
import Logo4 from "../../assests/images/Max_Life_Insurance_logo.svg";
import Logo5 from "../../assests/images/motilal.png";
import Think from "../../assests/images/thinking-png-31407.png"
import styles from "./home.module.scss";

const HomePage = () => {
  return (
    <div className={styles.wrapper}>
      {/* HERO SECTION */}
      <section className={styles.heroSection}>
        <Row align="middle" gutter={[48, 48]}>
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1>
                Building Careers.
                <br />
                <span>Powering Businesses.</span>
              </h1>

              <p className={styles.heroText}>
                Shivant HR Consultancy delivers precision hiring solutions
                across IT, BFSI, Pharma, and multiple industries across India.
              </p>

              <div className={styles.heroActions}>
                <Button type="primary" size="large">
                  <Link to="/contact">Get in Touch</Link>
                </Button>

                <Button size="large" ghost>
                  <Link to="/services">Our Services</Link>
                </Button>
              </div>
            </motion.div>
          </Col>

          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              className={styles.heroVisual}
            >
              {/* <div className={styles.heroCircle} /> */}
              <img src={Think} alt="Client Logo" width={400} />
            </motion.div>
          </Col>
        </Row>
      </section>

      {/* STATS SECTION */}
      <section className={styles.statsSection}>
        <Row gutter={[24, 24]}>
          {[
            { label: "Years of Experience", value: "5+" },
            { label: "Industries Served", value: "10+" },
            { label: "Successful Closures", value: "500+" },
          ].map((item, index) => (
            <Col xs={24} md={8} key={index}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <Card className={styles.statCard}>
                  <h2>{item.value}</h2>
                  <p>{item.label}</p>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </section>

      {/* CTA SECTION */}
      <section className={styles.ctaSection}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className={styles.ctaCard}
        >
          <h2>Looking to hire the right talent?</h2>
          <p>
            Partner with Shivant HR Consultancy and experience recruitment
            driven by strategy, speed, and quality.
          </p>
          <Button type="primary" size="large">
            <Link to="/contact">Talk to Us</Link>
          </Button>
        </motion.div>
      </section>
      {/* LOGO SLIDER SECTION */}
<section className={styles.logoSection}>
  <h3 className={styles.logoTitle}>Trusted by Leading Companies</h3>

  <div className={styles.slider}>
    <div className={styles.slideTrack}>
      {[Logo1, Logo2, Logo3, Logo4, Logo5, Logo1, Logo2].map(
        (logo, index) => (
          <div className={styles.slide} key={index}>
            <img src={logo} alt="Client Logo" />
          </div>
        )
      )}
    </div>
  </div>
</section>

    </div>
  );
};

export default HomePage;
